/* Reiselieblinge: Startseite – Produkt-Highlight. Farbe als runde Farbkreise wie auf der NeckDream-Seite, Schwarz vorausgewaehlt. */
(function () {
  var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var COL = { 'schwarz': '#1d1d1f', 'black': '#1d1d1f', 'grau': '#8E8E93', 'grey': '#8E8E93', 'gray': '#8E8E93', 'korallrot': '#D24F4A', 'coral red': '#D24F4A', 'coral': '#D24F4A', 'rot': '#D24F4A', 'red': '#D24F4A' };
  var ORDER = ['schwarz', 'black', 'grau', 'grey', 'gray', 'korallrot', 'coral red', 'coral', 'rot', 'red'];

  function css() {
    if (document.getElementById('rl-hv-css')) return;
    var s = document.createElement('style');
    s.id = 'rl-hv-css';
    s.textContent =
      '.rl-hv-sel{position:absolute!important;width:1px!important;height:1px!important;opacity:0!important;pointer-events:none!important;overflow:hidden!important;clip:rect(0 0 0 0)!important}' +
      '.rl-hv-name{text-transform:none;letter-spacing:0;font-weight:600;color:#9C7556;margin-left:6px;font-size:13px}' +
      '.rl-hv-sw{display:flex;flex-wrap:wrap;gap:10px;margin:10px 0 6px}' +
      '.rl-hv-sw button{width:38px;height:38px;border-radius:50%;border:0;padding:0;background:var(--c);cursor:pointer;box-shadow:inset 0 0 0 1px rgba(0,0,0,.12);transition:transform .15s,box-shadow .15s}' +
      '.rl-hv-sw button:hover{transform:scale(1.06)}' +
      '.rl-hv-sw button[aria-pressed="true"]{box-shadow:0 0 0 3px #fff,0 0 0 4.5px #9C7556}' +
      '.rl-hv-sw button:focus-visible{outline:2px solid #9C7556;outline-offset:4px}';
    document.head.appendChild(s);
  }

  function init(root) {
    if (root.dataset.rlSwatches) return;
    var select = root.querySelector('[data-rl-highlight-variant]');
    var button = root.querySelector('[data-rl-highlight-add]');
    if (!select || !button) return;
    root.dataset.rlSwatches = '1';
    css();

    var opts = [].slice.call(select.options).filter(function (o) { return o.value; });
    if (!opts.length) return;
    /* Bilder nicht pro Variante tauschen – das Hauptbild bleibt stehen */
    opts.forEach(function (o) { delete o.dataset.image; delete o.dataset.imageAlt; });
    opts.sort(function (a, b) {
      var ia = ORDER.indexOf(a.textContent.trim().toLowerCase()), ib = ORDER.indexOf(b.textContent.trim().toLowerCase());
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });

    var label = root.querySelector('.rl-product-highlight__variant-label');
    var nameEl = document.createElement('span');
    nameEl.className = 'rl-hv-name';
    if (label) { label.textContent = en ? 'Colour:' : 'Farbe:'; label.appendChild(nameEl); }

    var wrap = document.createElement('div');
    wrap.className = 'rl-hv-sw';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', en ? 'Colour' : 'Farbe');

    /* Startseite: Bild je Farbe aus den Abschnitts-Einstellungen (Theme-Editor). Ohne Bild bleibt das Titelbild. */
    var img = root.querySelector('.rl-product-highlight__media img');
    var orig = img ? { src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), alt: img.getAttribute('alt') } : null;
    function swap(o) {
      if (!img) return;
      var d = o.dataset;
      if (d.rlImg) {
        img.src = d.rlImg;
        img.srcset = d.rlSrcset || '';
        img.alt = d.rlAlt || img.alt;
      } else if (orig) {
        img.src = orig.src;
        if (orig.srcset) img.srcset = orig.srcset; else img.removeAttribute('srcset');
        img.alt = orig.alt || '';
      }
      var a = root.querySelector('.rl-product-highlight__media');
      if (a && a.href) { try { var u = new URL(a.href); u.searchParams.set('variant', o.value); a.href = u.toString(); } catch (e) {} }
    }
    opts.forEach(function (o) { if (o.dataset.rlImg) { var p = new Image(); if (o.dataset.rlSrcset) { p.sizes = img && img.sizes || '440px'; p.srcset = o.dataset.rlSrcset; } p.src = o.dataset.rlImg; } });

    function pick(o, fire) {
      swap(o);
      select.value = o.value;
      button.dataset.variantId = o.value;
      nameEl.textContent = o.textContent.trim();
      [].forEach.call(wrap.children, function (b) { b.setAttribute('aria-pressed', b.dataset.v === o.value ? 'true' : 'false'); });
      if (fire) select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    opts.forEach(function (o) {
      var n = o.textContent.trim();
      var b = document.createElement('button');
      b.type = 'button';
      b.dataset.v = o.value;
      b.title = n;
      b.setAttribute('aria-label', n);
      b.style.setProperty('--c', COL[n.toLowerCase()] || '#ccc');
      if (o.disabled || o.dataset.available === 'false') b.disabled = true;
      b.addEventListener('click', function () { pick(o, true); });
      wrap.appendChild(b);
    });

    select.classList.add('rl-hv-sel');
    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');
    select.insertAdjacentElement('afterend', wrap);

    var first = opts.filter(function (o) { return !o.disabled && o.dataset.available !== 'false'; })[0] || opts[0];
    pick(first, true);
  }

  function run() { document.querySelectorAll('[data-rl-product-highlight]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Reiselieblinge: Englische Seiten – fest eingetragene Links auf /en umstellen, Farbpunkte mit englischen Farbnamen einfaerben */
(function () {
  if ((document.documentElement.lang || '').toLowerCase().indexOf('en') !== 0) return;
  var DOT = { 'black': '#1d1d1f', 'grey': '#8E8E93', 'gray': '#8E8E93', 'coral red': '#D24F4A', 'champagne': '#e7d3b3', 'pink': '#efc7cd', 'light grey': '#cfcfd2', 'dark blue': '#1f2a44', 'dark green': '#23443a', 'white': '#f4f4f1', 'lilac': '#b7a1d4' };
  function run() {
    document.querySelectorAll('a[href^="/collections/"],a[href^="/products/"],a[href^="/pages/"],a[href^="/blogs/"]').forEach(function (a) {
      a.setAttribute('href', '/en' + a.getAttribute('href'));
    });
    document.querySelectorAll('.dots i[data-c]').forEach(function (i) {
      var c = DOT[(i.dataset.c || '').toLowerCase()];
      if (c) i.style.setProperty('--c', c);
    });
    document.querySelectorAll('.section-rl-home-range .ch b, .section-rl-home-range .sx > .rl').forEach(function (el) {
      if (el.textContent.trim() === 'Dream-Sets') el.textContent = 'Dream Sets';
    });
    /* Restliche fest im Theme stehende deutsche Texte (Reiseguide-Produktseite, NeckDream-Kopf, Magazin) */
    var TX = [
      [/^Komfort für unterwegs\.$/, 'Comfort on the go.'],
      [/LIEBLINGSGUIDE FÜR/, 'FAVOURITE GUIDE FOR'],
      [/^Sofort verfügbar · PDF$/, 'Available immediately · PDF'],
      [/^Sofort verfügbar als PDF\.$/, 'Available immediately as a PDF.'],
      [/^Sofort verfügbar$/, 'Available immediately'],
      [/^Drei echte Einblicke: Orientierung, handverlesene Adressen und praktische Planung für (.+)\.$/, 'Three real insights: orientation, hand-picked places and practical planning for $1.'],
      [/BAUSTEINE · KLAR FÜR UNTERWEGS/, 'BUILDING BLOCKS · READY FOR THE ROAD'],
      [/^Der digitale Reiselieblinge Reiseguide für (.+?) bündelt handverlesene Restaurants, Cafés, Viertel, besondere Orte, Routen und praktische Tipps\. Statt endloser Listen bekommst du Kontext für bessere Entscheidungen – damit du vor Ort weniger recherchierst und mehr erlebst\.$/, 'The digital Reiselieblinge travel guide for $1 brings together hand-picked restaurants, cafés, neighbourhoods, special places, routes and practical tips. Instead of endless lists, you get context for better decisions – so you spend less time researching and more time experiencing.'],
      [/^Für alle, die lieber reisen als recherchieren\.$/, 'For everyone who would rather travel than research.'],
      [/^Nur Empfehlungen mit echtem Mehrwert – statt endloser Listen ohne Einordnung\.$/, 'Only recommendations with real added value – instead of endless lists without context.'],
      [/^Kontext zu Vierteln, Tageszeiten und Wegen macht deine Tagesplanung schneller und klarer\.$/, 'Context on neighbourhoods, times of day and routes makes planning your days quicker and clearer.'],
      [/^Weniger Recherche und Umwege\. Mehr Zeit für Orte und Momente, die in Erinnerung bleiben\.$/, 'Less research and fewer detours. More time for places and moments that stay with you.'],
      [/^Keine Beiträge in dieser Kategorie gefunden\.$/, 'No posts found in this category.'],
      [/^Packen & Ausrüstung$/, 'Packing & gear'],
      [/^Bitte auswählen$/, 'Please select']
    ];
    var main = document.querySelector('main') || document.body;
    var w = document.createTreeWalker(main, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      var t = n.nodeValue, s = t.trim();
      if (!s || !/[äöüÄÖÜß]|Sofort|BAUSTEINE|Keine|Kontext/.test(s)) continue;
      for (var k = 0; k < TX.length; k++) {
        if (TX[k][0].test(s)) { n.nodeValue = t.replace(s, s.replace(TX[k][0], TX[k][1])); break; }
      }
    }
    var mh = document.querySelector('.nd-masthead[aria-label]');
    if (mh) mh.setAttribute('aria-label', 'NeckDream product overview');
  }
  function go() {
    run();
    var tm, m = document.querySelector('main') || document.body;
    if (window.MutationObserver) new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(run, 120); }).observe(m, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
